import Logo from "./Logo";
import { SUPPORT_EMAIL, WHATSAPP_DISPLAY, WHATSAPP_NUMBER, CALL_DISPLAY, CALL_NUMBER } from "../data/site";
import { Mail, MessageCircle, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="gdf-navy-bg text-slate-300 pt-16 pb-8" id="contact">
      <div className="max-w-7xl mx-auto px-6 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="bg-white/95 rounded-xl inline-block px-3 py-2">
            <Logo className="h-10" />
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-400">
            GIVERS DRIVEN FUNDS (PTY) LTD — a community fund with no limits and no fine print.
            Where banks say no, we work with you towards a YES.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 font-head">Contact us</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="flex items-center gap-2 hover:text-emerald-400" data-testid="footer-email">
                <Mail className="w-4 h-4" /> {SUPPORT_EMAIL}
              </a>
            </li>
            <li>
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-emerald-400" data-testid="footer-whatsapp">
                <MessageCircle className="w-4 h-4" /> {WHATSAPP_DISPLAY} (WhatsApp)
              </a>
            </li>
            <li>
              <a href={`tel:${CALL_NUMBER}`} className="flex items-center gap-2 hover:text-emerald-400" data-testid="footer-call">
                <Phone className="w-4 h-4" /> {CALL_DISPLAY} (Call us)
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 font-head">Bank reference</h4>
          <p className="text-sm text-slate-400">Always pay using your <span className="text-gold-dark text-amber-400 font-medium">initials and surname</span> as the reference so we can match your contribution.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-12 pt-6 border-t border-white/10 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-3">
        <p>© {new Date().getFullYear()} Givers Driven Funds (Pty) Ltd. All rights reserved.</p>
        <p>Contributions are community savings. Assistance is subject to a 6-month contribution history and available balance.</p>
      </div>
    </footer>
  );
}
